import * as React from 'react';

import {DelayBar} from 'shells/delay-bar/delay-bar';

import type {DueDateUnit} from 'nutshell-graphql-types';
import type {
    EditionFragment as DripEdition,
    SmsDripEditionFragment as SmsDripEdition,
    TimespanInput,
} from 'nutshell-graphql-types';

import {EditActiveDelayConfirmation} from './edit-active-delay-confirmation';

type Props = {
    edition: DripEdition | SmsDripEdition;
    recipientCountText?: string;
    isFirstEdition: boolean;
    onEditionUpdate: (
        editionId: string,
        sendDelay?: TimespanInput | null | undefined
    ) => Promise<any>;
    setIsShowingRecipientModal: (isShowing: boolean) => void;
    setIsRemovingItem: (isRemoving: boolean) => void;
};

export function DelayBarWrapper(props: Props) {
    if (!props.edition.delay) {
        return null;
    }

    return (
        <DelayBar
            delay={props.edition.delay}
            saveChanges={(unit: DueDateUnit, timespan: number) => {
                return props.onEditionUpdate(props.edition.id, {
                    unit: unit,
                    timespan: timespan,
                });
            }}
            recipientCountText={props.recipientCountText}
            onShowRecipientModal={
                props.edition.queuedDripProgressions &&
                props.edition.queuedDripProgressions.totalCount > 0
                    ? () => props.setIsShowingRecipientModal(true)
                    : undefined
            }
            // Can edit draft or active editions from this page
            isEditable={
                props.edition.status === 'NEW' ||
                props.edition.status === 'SENDING' ||
                props.edition.status === 'PAUSED'
            }
            editActiveDelayConfirmationDialog={
                props.edition.status === 'SENDING' && props.edition.__typename === 'Edition'
                    ? EditActiveDelayConfirmation
                    : undefined
            }
            editionId={props.edition.id}
            editionName={props.edition.name}
            isFirstDelay={props.isFirstEdition}
            removeFirstDelay={
                props.isFirstEdition
                    ? () => {
                          // The delay animation has to start before the delay is *actually* removed
                          // because animation can't happen after it is deleted because it is gone
                          props.setIsRemovingItem(true);

                          return props
                              .onEditionUpdate(props.edition.id, null)
                              .then(() => {
                                  // To animate the delay fading out
                                  props.setIsRemovingItem(false);
                              })
                              .catch(() => {
                                  // If there is an error for some reason, reset isRemovingItem to false,
                                  // There will still be a delay for the sequence, so it will fade out and
                                  // fade back in (displaying normally). Might be good to show an error message
                                  // but this is super unlikely to actually happen.
                                  props.setIsRemovingItem(false);
                              });
                      }
                    : undefined
            }
            isActive={props.edition.status === 'SENDING'}
        />
    );
}
